<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="4">
        <v-alert
          v-if="error_message"
          type="error"
          dismissible
        >
          {{ error_message }}
        </v-alert>

        <v-card>
          <v-card-title>Sign In</v-card-title>
          <v-card-text>
            <p>Sign in with your Okta account to continue.</p>
            <v-btn
              color="primary"
              @click="signIn()"
            >
              Sign in with Okta
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SignIn",
  data() {
    return {
      error_message: null,
    };
  },
  methods: {
    signIn() {
      this.error_message = null;
      this.$store
        .dispatch("signIn")
        .catch((err) => (this.error_message = err.message));
    },
  },
};
</script>
<style scoped></style>
